import { policyTypeMdl } from './../../../Models/policyTypeMdl';
import { MedmalBindMdl } from './../../../Models/MedmalBindMdl';
import { Subscription } from 'rxjs';
import { LanguageService } from './../../../Services/languageService';
import { restURL } from './../../../Models/restURL';
import { Router } from '@angular/router';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { MedmalProposal } from './../../../Models/MedmalProposal';
import { userService } from '../../../Services/userService';
import Swal from 'sweetalert2';
import { motorProposalService } from '../../../Services/motorProposalService';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';
import { MotorStatusMdl } from '../../../Models/MotorStatusMdl';
import { mdlSaudiPostAddress } from '../../../Models/mdlSaudiPostAddress';
import { APIService } from '../../../Services/api.service';
import { EncryptionService } from '../../../Services/EncryptionService';

@Component({
  selector: 'MedmalNewProposal',
  templateUrl: './MedmalNewProposal.html',
  styleUrls: ['./MedmalNewProposal.css']
})
export class MedmalNewProposal {

  public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  public isShowLoading: boolean = false;
  public LngSubscription: Subscription;
  public medmalBindObj: MedmalBindMdl = new MedmalBindMdl();
  public medmalPolicyObj: policyTypeMdl = new policyTypeMdl();
  public proposalObj: MedmalProposal = new MedmalProposal();
  public Lng: any;
  public isError: boolean;
  public HasSaudiAddress: boolean;
  public HasClaim: boolean | undefined;
  public searchhospital: string | undefined;
  public SearchProfession: string | undefined;
  public LiabilityTooltip: string;
  public MedMalBasicTooltip: string;
  public MedMalPlusTooltip: string;
  public MedMalLogoTooltip: string;
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();
  public isLockFields: boolean = false;
  public MM: string;
  public YYYY: string;

  public apiUrl: restURL = new restURL()
  public isAddressCorrect: boolean = true;
  public ObjSaudiPostAdr: mdlSaudiPostAddress = new mdlSaudiPostAddress();
  public st: MotorStatusMdl = new MotorStatusMdl();
  public IsAddressUpdated: boolean | undefined;

  public IsPrevPolicyExist: boolean | undefined;
  public minDate: any;
  public maxDate: any;
  public IsPrevToUnder14days: boolean = false;
  public IsPrevRetroUnder14Days: boolean = true;
  public ShowPrevRetroRadio: boolean | undefined;

  public IsDetailsPanel: boolean = false;
  public IsInsuredPanel: boolean = true;

  public RetroActiveTooltip: string = "التغطية التأمينية الالزامية لمدة سابقة لتاريخ سريان الوثيقة لا تتجازو 14 يوم تقومي , وتلتزم الشركة بالتأمين بالأثر الرجعي الألزامي من تاريخ سريان التغطية التأمينية لأول وثيقة ابرمت مع الشركة وحتى انتهاء مدة التغطية لأخر وثيقة ابرمت مع الشركة";
  public AddRetroActiveTooltip: string = "التغطية التأمينية التي قررت الشركة منحها للمؤمن لمدة سابقة لتاريخ سريان الوثيقة في حال وجود انقطاع لمدة أكثر من 14 يوم تقويمي ) وذلك بقسط اضافي . بحيث يتم التغطية من تاريخ سريان التغطية التأمينيه لأول وثيقة ابرمت سوءً مع نفس الشركة او شركة اخرى . بشرط ان يكون الخطأ الطبي غير معلوم للمؤمن له عند ابرام الوثيقة";
  public DeductibleTooltip: string = "النسبة التي يتحملها المؤمن له من قيمة التعويض حسب المتفق عليه عند ابرام العقد";
  public ExtendedTooltip: string = "في حال وقوع أي حادث أو ظرف قد يؤدي إلى مطالبة مقبولة، يجب على المؤمن له تبليغ الشركة في أقرب وقت ممكن على أن يكون التبليغ خلال فترة سريان الوثيقة . وعند اضافة هذه المنفعة تسمح للمؤمن له بمدة إضافية للتبليغ عن أي مطالبة نشأت خلال مدة سريان الوثيقة والتي تبدأ من تاريخ انتهاء الوثيقة المبرمة أو إلغائها، وتنتهي بانتهاء مدة التبليغ كحد اقصى 12 شهراً ";

  public InsuredEmail:string;
  public InsuredMobileNo:string;

  public HospitalName:string;

  constructor(private EncriptService: EncryptionService, private router: Router, private http: HttpClient, private url: restURL, private lngService: LanguageService, private userinfo: userService,
    private APISer: APIService) {

    this.LngSubscription = this.lngService.grtLng().subscribe(lng => {
      this.Lng = lng;
      if (this.Lng == "ar") {
        this.MedMalBasicTooltip = "<p>وتشمل: دفع التعويضات (استرداد الحق الخاص) ، تلبية متطلبات الهيئة السعودية للتخصصات الصحية.</p> ";
        this.MedMalPlusTooltip = "<p>وتشمل: دفع التعويضات (استرداد الحق الخاص) ، تلبية متطلبات الهيئة السعودية للتخصصات الصحية ، إصدار فوري لخطاب الضمان في حال الحاجة إلى السفر، دعم الدخل (بدل التوقف عن العمل).</p>";
        this.LiabilityTooltip = "حدود المسؤولية: الحد الأقصى لمقدار المسؤولية التي يكون المؤمّن مسؤولاً عن تعويض المؤمن عليه في حالة المطالبة ، وفقًا لشروط وأحكام الوثيقة";
        this.MedMalLogoTooltip = "<p>لمن هذه الوثيقة ؟<p/><p>هذه الوثيقة معدة للمهنيين العاملين في المجال الصحي، بما في ذلك، الجراحيين، الأطباء، أطباء الأسنان، الممرضين، المسعفين، الصيادلة، والمعالجين وفنيي المختبرات وغيرهم من المهنيين الطبيين.</p><br><p> نطاق التغطية !<p/><p>المسؤولية القانونية عن أي فعل بالخطأ، أو الإغفال عن تقديم الخدمات المهنية الناتج عنها: الضرر الجسدي ، التعب، المرض، أو الوفاه لأي مريض لا سمح الله</p>";
      } else {
        this.MedMalBasicTooltip = "<ul><li>It Provides Payment of Compensation(Private Right Recovery).</li><br><li>It Meets the requirements of Saudi Commission for Health Speciality (SCHS).</li></ul> ";
        this.MedMalPlusTooltip = "<ul><li>It Provides Payment of Compensation.</li><br><li>Immediate Issuance of Letter of Guarantee in case of restraint to travel.</li><br><li>Provides Income Support.</li><br><li>It Meets the requirements of Saudi Commission for Health Specialty (SCHS).</li></ul>";
        this.LiabilityTooltip = "The maximum amount of liability for which the insurer would be responsible to indemnify the insured in case of a claim, subject to the terms and conditions of the policy.";
        this.MedMalLogoTooltip = "<p>To Whom is This Policy For?<p/><p>This Policy is designed for professionals in healthcare field which includes surgeons, doctors, dentists, nurses, paramedics, pharmacists, therapists, laboratory technicians and other medical professionals.</p><br><p>SCOPE OF COVER<p/><p>Legal liability of any act, ,failure to act or omission in the provision of Professional Services that resulted to bodily injury, sickness, illness, death to any patient.</p>";
      }
    });
    this.isError = false;
    this.HasSaudiAddress = true;
    if (sessionStorage.getItem("Language") != null) {
      this.Lng = sessionStorage.getItem("Language");
      if (this.Lng == "ar") {
        this.MedMalBasicTooltip = "<p>وتشمل: دفع التعويضات (استرداد الحق الخاص) ، تلبية متطلبات الهيئة السعودية للتخصصات الصحية.</p> ";
        this.MedMalPlusTooltip = "<p>وتشمل: دفع التعويضات (استرداد الحق الخاص) ، تلبية متطلبات الهيئة السعودية للتخصصات الصحية ، إصدار فوري لخطاب الضمان في حال الحاجة إلى السفر، دعم الدخل (بدل التوقف عن العمل).</p>";
        this.LiabilityTooltip = "حدود المسؤولية: الحد الأقصى لمقدار المسؤولية التي يكون المؤمّن مسؤولاً عن تعويض المؤمن عليه في حالة المطالبة ، وفقًا لشروط وأحكام الوثيقة";
        this.MedMalLogoTooltip = "<p>لمن هذه الوثيقة ؟<p/><p>هذه الوثيقة معدة للمهنيين العاملين في المجال الصحي، بما في ذلك، الجراحيين، الأطباء، أطباء الأسنان، الممرضين، المسعفين، الصيادلة، والمعالجين وفنيي المختبرات وغيرهم من المهنيين الطبيين.</p><br><p> نطاق التغطية !<p/><p>المسؤولية القانونية عن أي فعل بالخطأ، أو الإغفال عن تقديم الخدمات المهنية الناتج عنها: الضرر الجسدي ، التعب، المرض، أو الوفاه لأي مريض لا سمح الله</p>";
      } else {
        this.MedMalBasicTooltip = "<ul><li>It Provides Payment of Compensation(Private Right Recovery).</li><br><li>It Meets the requirements of Saudi Commission for Health Speciality (SCHS).</li></ul> ";
        this.MedMalPlusTooltip = "<ul><li>It Provides Payment of Compensation.</li><br><li>Immediate Issuance of Letter of Guarantee in case of restraint to travel.</li><br><li>Provides Income Support.</li><br><li>It Meets the requirements of Saudi Commission for Health Specialty (SCHS).</li></ul>";
        this.LiabilityTooltip = "The maximum amount of liability for which the insurer would be responsible to indemnify the insured in case of a claim, subject to the terms and conditions of the policy.";
        this.MedMalLogoTooltip = "<p>To Whom is This Policy For?<p/><p>This Policy is designed for professionals in healthcare field which includes surgeons, doctors, dentists, nurses, paramedics, pharmacists, therapists, laboratory technicians and other medical professionals.</p><br><p>SCOPE OF COVER<p/><p>Legal liability of any act, ,failure to act or omission in the provision of Professional Services that resulted to bodily injury, sickness, illness, death to any patient.</p>";
      }
    }
    else {
      this.Lng = "en";
      this.LiabilityTooltip = "The maximum amount of liability for which the insurer would be responsible to indemnify the insured in case of a claim, subject to the terms and conditions of the policy.";
      this.MedMalBasicTooltip = "<ul><li>It Provides Payment of Compensation(Private Right Recovery).</li><br><li>It Meets the requirements of Saudi Commission for Health Speciality (SCHS).</li></ul> ";
      this.MedMalPlusTooltip = "<ul><li>It Provides Payment of Compensation.</li><br><li>Immediate Issuance of Letter of Guarantee in case of restraint to travel.</li><br><li>Provides Income Support.</li><br><li>It Meets the requirements of Saudi Commission for Health Specialty (SCHS).</li></ul>";
      this.MedMalLogoTooltip = "<p>To Whom is This Policy For?<p/><p>This Policy is designed for professionals in healthcare field which includes surgeons, doctors, dentists, nurses, paramedics, pharmacists, therapists, laboratory technicians and other medical professionals.</p><br><p>SCOPE OF COVER<p/><p>Legal liability of any act, ,failure to act or omission in the provision of Professional Services that resulted to bodily injury, sickness, illness, death to any patient.</p>";
    }

    sessionStorage.setItem("UserId", this.EncriptService.EncriptObject("331"))

    let RegNo: any = sessionStorage.getItem("UserId")
    this.medmalBindObj.proposalObj.UserID = JSON.parse(this.EncriptService.DecriptObject(RegNo));


    sessionStorage.removeItem("medmalBindObj");
    sessionStorage.removeItem("medmalProposalObj");

    // this.getBindInfo();
    // this.medmalPolicyObj.IqamaNo = sessionStorage.getItem("IqamaNo");
    this.GetInsuredDetails();


  }

  async GetInsuredDetails() {

    let req = {
      RegNo: sessionStorage.getItem("RegNo")
    }
    this.isShowLoading = true;
    var APIRes = await this.APISer.ConnectAPI("/LimraMedmal/GetInsuredDetails", req)
    this.isShowLoading = false;
    var APIStatus = APIRes[0]
    if (APIStatus.StatusCode == "F") {
      Swal(APIStatus.StatusDesc, "", "error")
      return;
    }
    let Res = APIRes[1];

    if (APIRes[1].StatusCode == "F") {
      Swal(APIRes[1].StatusDesc, "", "error")
    }
    if (Res.st.StatusCode == "S") {
      this.InsuredEmail = Res.InsuredDetails.EmailId;
      this.InsuredMobileNo = Res.InsuredDetails.MobileNo;

      this.medmalPolicyObj.IqamaNo = Res.InsuredDetails.InsuredIdNo;
      if (this.medmalPolicyObj.IqamaNo.startsWith("1")) {
        this.medmalPolicyObj.DOBHijri = Res.InsuredDetails.DOB;
      }
      else {
        this.medmalPolicyObj.DOB = Res.InsuredDetails.DOB;
      }
      this.getBindInfo();
    }
    else{
      Swal(Res.st.StatusDescEn, "", "error")
      this.router.navigate(['Menu/Welcome']);
      return;
    }


  }

  async getBindInfo() {

    // this.medmalPolicyObj.IqamaNo = "2045564024";
    // this.MM="01";
    // this.YYYY="1983"

    // if (this.medmalPolicyObj.IqamaNo.startsWith("1")) {
    //   this.medmalPolicyObj.DOBHijri = this.MM + "-" + this.YYYY;
    // }
    // else {
    //   this.medmalPolicyObj.DOB = this.MM + "-" + this.YYYY;
    // }
    this.isShowLoading = true;
    var APIRes = await this.APISer.ConnectAPI("/LimraMedmal/BindMedmalInfo", this.medmalPolicyObj)
    this.isShowLoading = false;
    var APIStatus = APIRes[0]
    if (APIStatus.StatusCode == "F") {
      Swal(APIStatus.StatusDesc, "", "error")
      return;
    }
    this.medmalBindObj = APIRes[1];

    if (APIRes[1].StatusCode == "F") {
      Swal(APIRes[1].StatusDesc, "", "error")
    }
    if (this.medmalBindObj.proposalObj.PrevPolicyNo == undefined || this.medmalBindObj.proposalObj.PrevPolicyNo == null || this.medmalBindObj.proposalObj.PrevPolicyNo.length == 0) {
      this.medmalBindObj.proposalObj.IsICPrvPolicy = false;
    }
    else {
      this.medmalBindObj.proposalObj.IsICPrvPolicy = true;
    }

    this.CheckPrevPolicyExist("");


    if (this.medmalBindObj.st.StatusCode == "F") {
      this.router.navigate(['Menu/Welcome']);
      Swal(this.medmalBindObj.st.StatusDescEn, "", "error")
      return;
    } else {
      this.IsInsuredPanel = false;
      this.IsDetailsPanel = true;

      this.medmalBindObj.proposalObj.DeductableCode = this.medmalBindObj.DeductableList.filter(t => t.DeductableDesc_Eng == "0")[0].DeductableCode;

    }


    if (this.medmalBindObj.st.StatusCode == "Y") {
      this.HasSaudiAddress = false;
      //this.Lng=="en"? alert(this.medmalBindObj.st.StatusDescEn):alert(this.medmalBindObj.st.StatusDescAr);
      //this.Lng == "en" ? alert("Dear customer Please register or update your own National Address:https://register.address.gov.sa/ar/individual/") : alert("عزيزنا العميل نرجو تسجيل أو تحديث بياناتك في العنوان الوطني عن طريق الرابط التالي:https://register.address.gov.sa/ar/individual/");
      if (this.Lng == "en") {
        let stHTML: string;
        stHTML = "<p style='font-size:16px;'>Dear customer Please register or update your own National Address: <a href='https://register.address.gov.sa/ar/individual/' target='_blank'>https://register.address.gov.sa/ar/individual/" + "</a></p>";
        Swal({
          title: "''",
          html: stHTML,
          width: '50%',
        });
      } else {
        let stHTML: string;
        stHTML = "<p style='font-size:16px;'>عزيزنا العميل نرجو تسجيل أو تحديث بياناتك في العنوان الوطني عن طريق الرابط التالي<a href='https://register.address.gov.sa/ar/individual/' target='_blank'>https://register.address.gov.sa/ar/individual/" + "</a></p>";
        Swal({
          title: '',
          html: stHTML,
          width: '50%',
        });
      }
    }
    else {
      this.isShowLoading = false;
      if (this.medmalBindObj.st.StatusCode == "F") {
        this.Lng == "en" ? Swal(this.medmalBindObj.st.StatusDescEn) : Swal(this.medmalBindObj.st.StatusDescAr);
        this.isError = true;
        this.isShowLoading = false;
      }
      else {
        if (sessionStorage.getItem("IsMedMalEdit") == "Y") {
          let optionvalue = document.getElementById("optionvalue");
          if (optionvalue) optionvalue.innerHTML = this.Lng == "en" ? this.medmalBindObj.hospList.filter(t => t.HospitalCode == this.medmalBindObj.proposalObj.Insured_HospId)[0].HospitalNameEn : this.medmalBindObj.hospList.filter(t => t.HospitalCode == this.medmalBindObj.proposalObj.Insured_HospId)[0].HospitalNameAr;
          let professionvalue = document.getElementById("professionvalue");
          if (professionvalue) professionvalue.innerHTML = this.Lng == "en" ? this.medmalBindObj.professionList.filter(t => t.ProfessionCode == this.medmalBindObj.proposalObj.Insured_Professioncode)[0].ProfessionDesc_Eng : this.medmalBindObj.professionList.filter(t => t.ProfessionCode == this.medmalBindObj.proposalObj.Insured_Professioncode)[0].ProfessionDesc_Ar;
        } else {
          this.medmalBindObj.proposalObj.IndemnityCode = "";
          this.medmalBindObj.proposalObj.SchemeCode = "";
          this.medmalBindObj.proposalObj.ProposalPeriod = "";
          this.searchhospital = ""
          this.SearchProfession = ""
          this.HospitalName = ""
          this.medmalBindObj.proposalObj.claimObj.claim1 = null
          this.medmalBindObj.proposalObj.claimObj.claim2 = null
          this.medmalBindObj.proposalObj.claimObj.claim3 = null
          this.medmalBindObj.proposalObj.claimObj.claimsInfo = null
          this.medmalBindObj.proposalObj.claimObj.NoOfClaims = undefined
          this.medmalBindObj.proposalObj.claimObj.TotalClaimsAmount = undefined
          this.medmalBindObj.proposalObj.DeductableCode = this.medmalBindObj.DeductableList.filter(t => t.DeductableDesc_Eng == "0")[0].DeductableCode;
        }
        this.isError = false;
        this.isShowLoading = false;
      }
    }
    this.BindFromSession();

    this.medmalBindObj.proposalObj.SchemeCode = "3";
  }

  async BUYPolicy(NewMedmalPolicyForm: any) {

    if (this.medmalBindObj.proposalObj.Insured_HospId == "0") {
      Swal("Empty Hospital Name", "Please select a Hospital to proceed further", "warning");
      return;
    }
    if (this.medmalBindObj.proposalObj.SchemeCode == "0") {
      Swal("Scheme", "Please select a Scheme to proceed further", "warning");
      return;
    }

    if (this.IsPrevPolicyExist && this.CalculateDays() < 360) {
      Swal("Previous Policy Period Must be alteast 360 days.", "", "info");
      return;
    }

    this.medmalBindObj.proposalObj.PrevPolicyFromDate = this.ConvertDate(this.medmalBindObj.proposalObj.PrevPolicyFromDate);
    this.medmalBindObj.proposalObj.PrevPolicyToDate = this.ConvertDate(this.medmalBindObj.proposalObj.PrevPolicyToDate);
    this.medmalBindObj.proposalObj.PrevPolicyRetroDate = this.ConvertDate(this.medmalBindObj.proposalObj.PrevPolicyRetroDate);
    this.medmalBindObj.proposalObj.RetroActiveDate = this.ConvertDate(this.medmalBindObj.proposalObj.RetroActiveDate);
    this.medmalBindObj.proposalObj.AdditionalRetroDate = this.ConvertDate(this.medmalBindObj.proposalObj.AdditionalRetroDate);

    this.medmalBindObj.proposalObj.Insured_MobileNo = this.InsuredMobileNo;
    this.medmalBindObj.proposalObj.Insured_EmailId = this.InsuredEmail;

    this.isShowLoading = true;
    sessionStorage.setItem("medmalBindObj", this.EncriptService.EncriptObject(JSON.stringify(this.medmalBindObj)));

    let RegNo2: any = sessionStorage.getItem("UserId")
    this.proposalObj.UserID = JSON.parse(this.EncriptService.DecriptObject(RegNo2));
    this.medmalBindObj.proposalObj.UserID = JSON.parse(this.EncriptService.DecriptObject(RegNo2));
    this.isShowLoading = true;
    var APIRes = await this.APISer.ConnectAPI("/LimraMedmal/CalculatePremium", this.medmalBindObj.proposalObj);
    var APIStatus = APIRes[0]
    if (APIStatus.StatusCode == "F") {
      Swal(APIStatus.StatusDesc, "", "error")
      return;
    }
    let objResObj: MedmalProposal = new MedmalProposal();
    objResObj = APIRes[1];

    this.proposalObj = objResObj;
    //NewLine End
    let UseriD: any = sessionStorage.getItem("UserId")
    this.proposalObj.UserID = JSON.parse(this.EncriptService.DecriptObject(UseriD));


    sessionStorage.setItem("medmalProposalObj", this.EncriptService.EncriptObject(JSON.stringify(this.proposalObj)));

    if (this.proposalObj.st.StatusCode == "F") {
      this.Lng == "en" ? Swal(this.proposalObj.st.StatusDescEn,"","error") : Swal(this.proposalObj.st.StatusDescAr,"","error");
      this.isError = true;
      this.isShowLoading = false;
    }
    else if (this.proposalObj.st.StatusCode == "P") {
      this.Lng == "en" ? Swal(this.proposalObj.st.StatusDescEn) : Swal(this.proposalObj.st.StatusDescAr);
      this.isShowLoading = false;
    }

    else if (this.proposalObj.st.StatusCode == "S") {
      this.isError = false;
      sessionStorage.setItem("CurrentRoute", "MedmalNewProposalConfirm");
      this.router.navigate(['NewDashboard/MedmalNewProposalConfirm']);
      this.isShowLoading = false;
    }

  }

  myFunction() {
    this.searchhospital = "";
    let myDropdown = document.getElementById("myDropdown");
    if (myDropdown) myDropdown.classList.toggle("show");
    let SearchInput = <HTMLInputElement>document.getElementById("myInput");
    if(SearchInput) SearchInput.focus();
  }

  filterFunction() {
    var input, filter, ul, li, a, i;
    input = document.getElementById("myInput") as HTMLInputElement;
    filter = input.value.toUpperCase();
    var div = document.getElementById("myDropdown") as HTMLInputElement;
    a = div.getElementsByTagName("option");
    for (i = 0; i < a.length; i++) {
      var txtValue = a[i].textContent || a[i].innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        a[i].style.display = "";
      } else {
        a[i].style.display = "none";
      }
    }
  }

  getValue(value: any) {
    this.medmalBindObj.proposalObj.Insured_HospId = value;
    let optionvalue = document.getElementById("optionvalue");
    if (optionvalue)
    {
      optionvalue.innerHTML = this.Lng == "en" ? this.medmalBindObj.hospList.filter((t: any) => t.HospitalCode == value)[0].HospitalNameEn : this.medmalBindObj.hospList.filter((t: any) => t.HospitalCode == value)[0].HospitalNameAr;
      this.HospitalName = optionvalue.innerHTML;
    } 
    let myDropdown = document.getElementById("myDropdown");
    if (myDropdown) myDropdown.style.display = "none";
    if (myDropdown) myDropdown.classList.remove('show');
  }

  ShowProfessions() {
    this.SearchProfession = "";
    let ProfessionDropdown = document.getElementById("ProfessionDropdown")
    if (ProfessionDropdown) ProfessionDropdown.classList.toggle("show");
    let SearchInput = <HTMLInputElement>document.getElementById("profInput");
    if(SearchInput) SearchInput.focus();
  }

  filterProfession() {
    var input, filter, ul, li, a, i;
    input = document.getElementById("profInput") as HTMLInputElement;

    filter = input.value.toUpperCase();
    var div = document.getElementById("ProfessionDropdown") as HTMLInputElement;
    a = div.getElementsByTagName("option");
    for (i = 0; i < a.length; i++) {
      var txtValue = a[i].textContent || a[i].innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        a[i].style.display = "";
      } else {
        a[i].style.display = "none";
      }
    }
  }

  getProfession(value: any) {
    this.medmalBindObj.proposalObj.Insured_Professioncode = value;
    let professionvalue = document.getElementById("professionvalue");
    if (professionvalue) professionvalue.innerHTML = this.Lng == "en" ? this.medmalBindObj.professionList.filter((t: any) => t.ProfessionCode == value)[0].ProfessionDesc_Eng : this.medmalBindObj.professionList.filter((t: any) => t.ProfessionCode == value)[0].ProfessionDesc_Ar;
    let ProfessionDropdown = document.getElementById("ProfessionDropdown");
    if (ProfessionDropdown) ProfessionDropdown.style.display = "none";
    if (ProfessionDropdown) ProfessionDropdown.classList.remove('show');

  }

  GetAddress() {
    this.isShowLoading = true;
    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify({
      IqamaNo: `${sessionStorage.getItem("IqamaNo")}`
    }));
    this.http.post<mdlPayloadResponse>(this.apiUrl.baseURL + "PolicySettings/GetAddress", this.objPayloadRequest, this.userinfo.getHttpOptions())
      .toPromise().then((result) => {
        this.objPayloadResponse = result;
        this.ObjSaudiPostAdr = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
        this.isShowLoading = false;
      }, (error) => {
        this.isShowLoading = false;
        this.userinfo.checkTokenStatus(error);
        this.Lng == "en" ? Swal("Try again later") : Swal("الرجاء معاودة المحاولة في وقت لاحق");
      });
  }

  UpdateAddress() {
    let objReq = {
      RegNo: sessionStorage.getItem("RegNo"),
      IqamaNo: sessionStorage.getItem("IqamaNo")
    }
    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(objReq));
    this.isShowLoading = true;
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/PolicySettings/UpdateAddress", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      this.isShowLoading = false;
      this.objPayloadResponse = result;
      this.st = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));

      if (this.st.StatusCode == "S") {
        this.IsAddressUpdated = true;
        this.isAddressCorrect = true;
        this.GetAddress();
        this.Lng == "en" ? Swal("Address Updated Successfully.", "", "success") : Swal("تم تحديث العنوان بنجاح", "", "success");
      } else {
        Swal(this.st.StatusDesc);
      }
    }, (error) => {
      this.userinfo.checkTokenStatus(error);
      this.Lng == "en" ? Swal(error.message, "", "error") : Swal(error.message, "", "error");
      this.isShowLoading = false;
    });
  }

  CheckPrevPolicyExist(word: any) {
    if (this.medmalBindObj.proposalObj.PrevPolicyNo == undefined || this.medmalBindObj.proposalObj.PrevPolicyNo == null || this.medmalBindObj.proposalObj.PrevPolicyNo.length == 0) {
      this.IsPrevPolicyExist = false;
      let RetroactiveDate = new Date(Date.now() + (3600 * 1000 * 24));
      // this.medmalBindObj.proposalObj.RetroActiveDate = formatDate(RetroactiveDate,'yyyy-MM-dd',"en-US").toString();

      var date = new Date();
      // add a day
      date.setDate(date.getDate() + 1);
      this.medmalBindObj.proposalObj.RetroActiveDate = this.ConvertDate(date)

      this.medmalBindObj.proposalObj.PrevPolicyFromDate = "";
      this.medmalBindObj.proposalObj.PrevPolicyToDate = "";
    } else {
      this.IsPrevPolicyExist = true;
      // this.medmalBindObj.proposalObj.PrevPolicyFromDate = "";
      // this.medmalBindObj.proposalObj.PrevPolicyToDate = "";
    }
  }

  CalculateDays() {
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const firstDate: any = new Date(this.medmalBindObj.proposalObj.PrevPolicyFromDate);
    const secondDate: any = new Date(this.medmalBindObj.proposalObj.PrevPolicyToDate);
    const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
    return diffDays
  }

  ConvertDate(DateInText: any) {
    if (DateInText == null || DateInText == "") {
      return "";
    }
    let date = new Date(DateInText);
    let YYYY = date.getFullYear();
    let MM = date.getMonth() + 1;
    let DD = date.getDate();
    let convertedFromDate = `${YYYY}-${MM}-${DD}`
    return convertedFromDate;
  }

  ToDateUnder14Days(event: any) {
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const PolicyTodate: any = new Date(this.medmalBindObj.proposalObj.PrevPolicyFromDate);
    const Today: any = new Date();
    // Today.setHours(0,0,0,0);
    const diffDays = Math.round(Math.abs((PolicyTodate - Today) / oneDay));

    this.medmalBindObj.proposalObj.PrevPolicyRetroDate = "";
    this.medmalBindObj.proposalObj.IsProvidedPrvRetroDate = false;



    if (diffDays <= 14) {
      this.IsPrevToUnder14days = true;
      this.medmalBindObj.proposalObj.RetroActiveDate = this.medmalBindObj.proposalObj.PrevPolicyFromDate;

    }
    else {
      this.IsPrevToUnder14days = false;
      let YYYY = Today.getFullYear();
      let MM = Today.getMonth() + 1;
      let DD = Today.getDate() + 1;
      this.medmalBindObj.proposalObj.RetroActiveDate = `${YYYY}-${MM}-${DD}`;
    }


  }

  PrevRetroActiveUnder14Days(event: any) {
    let RetroWarning = "This is a material fact and you are responsible for providing correct Retroactive Date. Any error intentional or otherwise shall jeopardize claim recovery under the Policy."
    let RetroWarningAr = "هذه حقيقة مادية وأنت مسؤول عن تقديم التاريخ الصحيح بأثر رجعي. أي عمل متعمد أو غير مشروع بطريقة أخرى سوف يعرض للخطر استرداد المطالبات بموجب السياسة."
    Swal(this.Lng == 'en' ? RetroWarning : RetroWarningAr, "", "warning");

    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const PrevRetroDate: any = new Date(this.medmalBindObj.proposalObj.PrevPolicyRetroDate);
    const Today: any = new Date();
    // Today.setHours(0,0,0,0);
    const diffDays = Math.round(Math.abs((PrevRetroDate - Today) / oneDay));

    if (diffDays <= 14) {
      this.IsPrevRetroUnder14Days = true;
      this.medmalBindObj.proposalObj.RetroActiveDate = this.medmalBindObj.proposalObj.PrevPolicyRetroDate;
      this.medmalBindObj.proposalObj.IsAdditionalRetro = false;
    }
    else {
      this.IsPrevRetroUnder14Days = false;
      let YYYY = Today.getFullYear();
      let MM = Today.getMonth() + 1;
      let DD = Today.getDate() + 1;
      this.medmalBindObj.proposalObj.RetroActiveDate = `${YYYY}-${MM}-${DD}`;
    }
  }

  BindFromSession() {


    if (sessionStorage.getItem("medmalBindObj") != null) {
      let medmalBindObj = new MedmalBindMdl();
      let medmalBind = sessionStorage.getItem("medmalBindObj")
      if (medmalBind) medmalBindObj = JSON.parse(this.EncriptService.DecriptObject(medmalBind));


      // Swal(medmalBindObj.proposalObj.SchemeCode)
      this.medmalBindObj.proposalObj.SchemeCode = medmalBindObj.proposalObj.SchemeCode;
      this.medmalBindObj.proposalObj.ProposalPeriod = medmalBindObj.proposalObj.ProposalPeriod;
      this.getValue(medmalBindObj.proposalObj.Insured_HospId);
      this.getProfession(medmalBindObj.proposalObj.Insured_Professioncode);
      this.medmalBindObj.proposalObj.IndemnityCode = medmalBindObj.proposalObj.IndemnityCode;
      this.medmalBindObj.proposalObj.Insured_HospitalName = medmalBindObj.proposalObj.Insured_HospitalName;
      this.medmalBindObj.proposalObj.PrevPolicyNo = medmalBindObj.proposalObj.PrevPolicyNo;
      this.medmalBindObj.proposalObj.PrevPolicyFromDate = medmalBindObj.proposalObj.PrevPolicyFromDate;
      this.medmalBindObj.proposalObj.PrevPolicyToDate = medmalBindObj.proposalObj.PrevPolicyToDate;

      this.medmalBindObj.proposalObj.IsProvidedPrvRetroDate = medmalBindObj.proposalObj.IsProvidedPrvRetroDate;
      this.medmalBindObj.proposalObj.PrevPolicyRetroDate = medmalBindObj.proposalObj.PrevPolicyRetroDate;
      this.medmalBindObj.proposalObj.RetroActiveDate = medmalBindObj.proposalObj.RetroActiveDate;


      this.medmalBindObj.proposalObj.IsAdditionalRetro = medmalBindObj.proposalObj.IsAdditionalRetro;
      this.medmalBindObj.proposalObj.AdditionalRetroDate = medmalBindObj.proposalObj.AdditionalRetroDate;

      this.medmalBindObj.proposalObj.ExtPeriodCode = medmalBindObj.proposalObj.ExtPeriodCode;
      this.medmalBindObj.proposalObj.DeductableCode = medmalBindObj.proposalObj.DeductableCode;


      this.medmalBindObj.proposalObj.claimObj.claim1 = medmalBindObj.proposalObj.claimObj.claim1;
      this.medmalBindObj.proposalObj.claimObj.claim2 = medmalBindObj.proposalObj.claimObj.claim2;
      this.medmalBindObj.proposalObj.claimObj.claim3 = medmalBindObj.proposalObj.claimObj.claim3;




      this.CheckPrevPolicyExist("");





    }

  }

  GetIndemnity() {

    if (this.medmalBindObj.proposalObj.Insured_Professioncode != undefined && this.medmalBindObj.proposalObj.Insured_Professioncode != null && this.medmalBindObj.proposalObj.Insured_Professioncode != "0") {
      let ProfClass: string = this.medmalBindObj.professionList.filter((t: any) => t.ProfessionCode == this.medmalBindObj.proposalObj.Insured_Professioncode)[0].ProfClassCode;
      //return this.medmalBindObj.indemnityList.filter(t=>t.ProfClassCode==this.medmalBindObj.professionList.filter(t=>t.ProfClassCode==this.medmalBindObj.proposalObj.Insured_Professioncode)[0].ProfClassCode);
      return this.medmalBindObj.indemnityList.filter((t: any) => t.ProfClassCode == ProfClass);
    }
    else {
      return this.medmalBindObj.indemnityList.filter((t: any) => t.ProfClassCode == "");
    }

  }

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MedmalPortal/MedmalNewProposal/MedmalNewProposal.ts